import _ from 'lodash';

import { COMPANY_PROPERTIES_ACTION_TYPE } from '../actions';

const initialState = {};

const propertiesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_PROPERTIES_ACTION_TYPE.GET_PROPERTIES:
      return _.groupBy(payload, 'companyId');

    case COMPANY_PROPERTIES_ACTION_TYPE.ADD_PROPERTY:
      return { ...state, [payload.companyId]: (state[payload.companyId] || []).concat(payload) };

    case COMPANY_PROPERTIES_ACTION_TYPE.REMOVE_PROPERTY:
      return {
        ...state,
        [payload.companyId]: (state[payload.companyId] || []).filter(
          property => payload.propertyName !== property.propertyName,
        ),
      };

    default:
      return state;
  }
};

export default propertiesReducer;
